module.exports = __webpack_public_path__ + "img/5-2.b3bfb03d.png";